import { DeliveryBarMachineContextShippingMethod } from './types';
import { ShippingMethod } from '@monofront/types';

/**
 * Transforms API shipping methods to machine context format
 */
export const transformShippingMethods = (
  methods: ShippingMethod[],
): DeliveryBarMachineContextShippingMethod[] => {
  return methods.reduce<DeliveryBarMachineContextShippingMethod[]>(
    (acc, shippingMethod) => {
      const sameType = acc.find(
        (method) => method.type === shippingMethod.type,
      );

      const config = {
        category: shippingMethod.category,
        aboveAllThresholdsAmount:
          shippingMethod.configuration.aboveAllThresholdsAmount,
        underThresholdAmount: shippingMethod.configuration.underThresholdAmount,
        cartTotalThreshold: shippingMethod.configuration.cartTotalThreshold,
        thresholds: shippingMethod.configuration.thresholds,
      };

      if (sameType && sameType.configurations) {
        sameType.configurations.push(config);

        return acc;
      }

      const newConfigurations = shippingMethod?.configuration ? [config] : [];

      acc.push({
        type: shippingMethod.type,
        carrierId: shippingMethod.tmsCode ?? '',
        configurations: newConfigurations,
      } as DeliveryBarMachineContextShippingMethod);

      return acc;
    },
    [],
  );
};
